import ComponentAccessControl from "components/essentials/ComponentAccessControl/ComponentAccessControl";
import { POST_FORM_READ_PERMISSION } from "./permissions";

const PostFormsAccessControl = ({
    children,
    baseResources = POST_FORM_READ_PERMISSION,
}) => (
    <ComponentAccessControl baseResources={baseResources}>
        {children}
    </ComponentAccessControl>
);

export default PostFormsAccessControl;
